import { FlowDetailPage } from './FlowDetail';

export default FlowDetailPage;
